export default __webpack_public_path__ + "static/media/product24.49ae057e.png";